export default __webpack_public_path__ + "static/media/nyspot.81d0306a.mp4";